import PropTypes from 'prop-types';
import React from 'react';

import { LocaleService } from '@sm360/widget-commons-core-services';

import ResolutionHeader from 'build-and-quote/components/OptionsResolutions/components/ResolutionHeader/ResolutionHeader.jsx';
import ResolutionFooter from 'build-and-quote/components/OptionsResolutions/components/ResolutionFooter/ResolutionFooter.jsx';
import ResolutionBlock from 'build-and-quote/components/OptionsResolutions/components/ResolutionBlock/ResolutionBlock.jsx';
import OptionSingle from 'build-and-quote/components/OptionsResolutions/components/OptionSingle/OptionSingle.jsx';

class OptionsResolutions extends React.Component {
    componentDidMount() {
        const firstResolution = this.props.selectionResolutions?.resolutions[0].id;
        this.props.purchaseMethodsActions.selectOptionsResolution(firstResolution);
    }

    render() {
        const {
            selectionResolutions,
            actions,
            purchaseMethodsActions,
            handleSettledResolutions,
            paymentFrequencyLabels,
        } = this.props;
        const { triggeredFromOptionAdd, triggerOption, resolutions, showPayments } = selectionResolutions || {};

        const addedOptionsTitle = (
            <div className="sr-text is-bold">
                <icon className="icon-Crochet is-success" /> {LocaleService.t('OPTIONS_RESOLUTIONS.OPTION_ADDED')}
            </div>
        );
        const removedOptionsTitle = (
            <div className="sr-text is-bold">
                <icon className="icon-x-config sr-errorColor" /> {LocaleService.t('OPTIONS_RESOLUTIONS.OPTION_REMOVED')}
            </div>
        );

        const resolutionsBlock =
            resolutions &&
            resolutions.map((resolution) => {
                const addedOptions = resolution.addedOptions.map((addedOption) => {
                    return (
                        <OptionSingle
                            key={addedOption.id}
                            description={addedOption.description}
                            retail={addedOption.retail}
                        />
                    );
                });
                const removedOptions = resolution.removedOptions.map((removedOption) => {
                    return (
                        <OptionSingle
                            key={removedOption.id}
                            description={removedOption.description}
                            retail={removedOption.retail}
                        />
                    );
                });

                const addedOptionsresolutionBlock = addedOptions.length > 0 && (
                    <div>
                        {addedOptionsTitle}
                        <ul className="optionsResolutions__resolutionBlock--optionsListing">{addedOptions}</ul>
                    </div>
                );

                const removedOptionsresolutionBlock = removedOptions.length > 0 && (
                    <div>
                        {removedOptionsTitle}
                        <ul className="optionsResolutions__resolutionBlock--optionsListing">{removedOptions}</ul>
                    </div>
                );

                const resolutionBlock = (
                    <div>
                        {addedOptionsresolutionBlock}
                        {removedOptionsresolutionBlock}
                    </div>
                );

                return (
                    <ResolutionBlock
                        id={resolution.id}
                        body={resolutionBlock}
                        pricingDifferenceTotal={resolution.pricingDifferenceTotal}
                        selected={resolution.selected}
                        selectOptionsResolution={purchaseMethodsActions.selectOptionsResolution}
                        showPayments={showPayments}
                        paymentFrequencyLabel={paymentFrequencyLabels.perPeriod}
                    />
                );
            });

        return selectionResolutions ? (
            <div className="optionsResolutions__wrapper">
                <ResolutionHeader
                    triggeredFromOptionAdd={triggeredFromOptionAdd}
                    triggerOption={triggerOption}
                    showPayments={showPayments}
                    paymentFrequencyLabel={paymentFrequencyLabels.perPeriod}
                />

                <h3 className="sr-text is-bold">{LocaleService.t('OPTIONS_RESOLUTIONS.OPTION_COMBINATION')}</h3>
                <br />

                {resolutionsBlock}

                <ResolutionFooter
                    actions={actions}
                    purchaseMethodsActions={purchaseMethodsActions}
                    onClose={handleSettledResolutions}
                />
            </div>
        ) : (
            ' '
        );
    }
}

OptionsResolutions.propTypes = {
    actions: PropTypes.shape({
        applyOptionSelectionResolution: PropTypes.func.isRequired,
    }).isRequired,
    handleSettledResolutions: PropTypes.func.isRequired,
    paymentFrequencyLabels: PropTypes.shape({
        periodically: PropTypes.string.isRequired,
        perPeriod: PropTypes.string.isRequired,
    }).isRequired,
    purchaseMethodsActions: PropTypes.shape({
        selectOptionsResolution: PropTypes.func.isRequired,
    }).isRequired,
    selectionResolutions: PropTypes.shape({
        resolutions: PropTypes.arrayOf(
            PropTypes.shape({
                addedOptions: PropTypes.shape({
                    description: PropTypes.string.isRequired,
                    imageUrl: PropTypes.string.isRequired,
                    payment: PropTypes.number.isRequired,
                    paymentTaxes: PropTypes.number.isRequired,
                    retail: PropTypes.number.isRequired,
                    taxes: PropTypes.number.isRequired,
                }).isRequired,
                id: PropTypes.string.isRequired,
                pricingDifferenceTotal: PropTypes.shape({
                    payment: PropTypes.number.isRequired,
                    paymentTaxes: PropTypes.number.isRequired,
                    retail: PropTypes.number.isRequired,
                    taxes: PropTypes.number.isRequired,
                }).isRequired,
                removedOptions: PropTypes.shape({
                    description: PropTypes.string.isRequired,
                    imageUrl: PropTypes.string.isRequired,
                    payment: PropTypes.number.isRequired,
                    paymentTaxes: PropTypes.number.isRequired,
                    retail: PropTypes.number.isRequired,
                    taxes: PropTypes.number.isRequired,
                }).isRequired,
                selected: PropTypes.bool.isRequired,
            })
        ),
        showPayments: PropTypes.bool.isRequired,
        triggeredFromOptionAdd: PropTypes.bool.isRequired,
        triggerOption: PropTypes.shape({
            description: PropTypes.string.isRequired,
            imageUrl: PropTypes.string.isRequired,
            payment: PropTypes.number.isRequired,
            paymentTaxes: PropTypes.number.isRequired,
            retail: PropTypes.number.isRequired,
            taxes: PropTypes.number.isRequired,
        }),
    }).isRequired,
};

OptionsResolutions.displayName = 'OptionsResolutions';

export default OptionsResolutions;
